import { StandardModal } from '@apply/components';
import { StandardModalDemoSidebar } from './components/StandardModalDemoSidebar';
import { StandardModalDemoFooter } from './components/StandardModalDemoFooter';

export interface StandardModalDemoProps {
    isOpen: boolean;
    onClose: () => void;
}

/** TEMP: Demo of StandardModal. Remove once the modal is in use. */
export const StandardModalDemo = ({ isOpen, onClose }: StandardModalDemoProps) => {
    return (
        <StandardModal
            id='standardModalTest'
            isOpen={isOpen}
            onClose={onClose}
            modalTitle='Standard Modal'
            sidebarTitle='Add Loan'
            sidebar={<StandardModalDemoSidebar />}
            footer={<StandardModalDemoFooter onSubmit={onClose} />}
            contentHeader='Property'
            contentHelpText='Enter the property information and address.'
            height={'90vh'}
            width={'95vw'}
        >
            <p>Main content goes here.</p>
        </StandardModal>
    );
};
